import {useState} from 'react';

import {SmartSearchVehicleApiResponse, useSmartSearchVehicleMutation} from '@dms/api/customer';

import {useDebouncedCallback} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';

export function useVehicleSmartSearch() {
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const [searchVehicles, setSearchVehicles] = useState<SmartSearchVehicleApiResponse | null>(null);
  const [suggestedVehicles, setSuggestedVehicles] = useState<SmartSearchVehicleApiResponse | null>(
    null
  );

  const [getSearchVehicles, {isLoading, isError}] = useSmartSearchVehicleMutation();

  const getSuggestedVehicles = async (customerId: string) => {
    await getSearchVehicles({
      body: {
        filters: {customerId},
        limit: 500,
        offset: 0,
        order: [
          {
            columnKey: 'vehicleTitle',
            order: 'ASC',
          },
        ],
      },
    })
      .unwrap()
      .then((result) => setSuggestedVehicles(result))
      .catch(handleApiError);
  };

  const resetSuggestedVehicles = () => {
    setSuggestedVehicles(null);
  };

  const handleSearchChange = useDebouncedCallback((customerId: string, query: string | null) => {
    setSearchQuery(query);

    if (!query) {
      setSearchVehicles(null);
      return;
    }

    getSearchVehicles({
      body: {
        filters: {
          customerId,
          smartSearch: query,
        },
        limit: 500,
        offset: 0,
        order: [
          {
            columnKey: 'vehicleTitle',
            order: 'ASC',
          },
        ],
      },
    })
      .unwrap()
      .then((result) => setSearchVehicles(result))
      .catch(handleApiError);
  }, 500);

  return {
    vehicles: searchQuery ? searchVehicles : suggestedVehicles,
    searchQuery,
    isLoading,
    isError,
    onSearchChange: handleSearchChange,
    getSuggestedVehicles,
    resetSuggestedVehicles,
  };
}
